import classNames from 'classnames';
import styles from './search-overview.module.scss';
import { useSearchOverviewMessage } from './searchOverviewMessage';

export type SearchOverviewProps = {
    searchQuery: string;
    totalRecords: number;
    isFulltextOnly?: boolean;
    containsCollapsed?: boolean;
};

const SearchOverview = ({ totalRecords, searchQuery, isFulltextOnly }: SearchOverviewProps) => {
    const overviewMessage = useSearchOverviewMessage({ totalRecords, searchQuery });
    const mobileOverviewMessage = useSearchOverviewMessage({ totalRecords, searchQuery, isMobile: true });

    return (
        <div>
            <div
                className={classNames(
                    styles.serpSearchOverview,
                    styles.searchOverviewDesktop,
                    isFulltextOnly ? styles.serpSearchOverviewFulltext : undefined
                )}
                data-testid="search-overview"
            >
                <p dangerouslySetInnerHTML={{ __html: overviewMessage }}></p>
            </div>

            <div
                className={classNames(
                    styles.serpSearchOverview,
                    styles.searchOverviewMobile,
                    isFulltextOnly ? styles.serpSearchOverviewFulltext : undefined
                )}
                data-testid="search-overview-mobile"
            >
                <p dangerouslySetInnerHTML={{ __html: mobileOverviewMessage }}></p>
            </div>
        </div>
    );
};

export default SearchOverview;
